<div class="sidenav-content" @routeAnimation *ngIf="!isSoldToLoading else spinner">

	<copo-panel-header [isBackButtonVisible]="true" (backButtonClick)="goBack()" 
		[titleHeaderText]="('auction.selection' |translate)">
	</copo-panel-header>
	<div class="copo-section">
		<copo-stepper class="copo-stepper-container" [steps]="steps"></copo-stepper>
		<div class="copo-section-header">
			<span translate>select.auction.title</span>
		</div>
	</div>
	<div class="copo-grid-container">
		<div class="copo-datacenter-tool-header">
			<mat-form-field class="copo-combobox-button" appearance="outline" subscriptSizing="dynamic">
				<mat-select [placeholder]="'datacenter.select-a-view' | translate">
				</mat-select>
			</mat-form-field>
			<button type="button" mat-stroked-button class="datacenter-customize-button">
				<span class="datacenter-customize-button-name" translate>datacenter.customize-view</span>
				<mat-icon iconPositionEnd class="datacenter-customize-button-icon" svgIcon="filters"></mat-icon>
			</button>
			<span translate [translateParams]="{ value: count | copoNumber:'number' }">datacenter.results</span>
		</div>
		<ag-grid-angular
			class="ag-theme-balham"
			[gridOptions]="offerGridOptions"
			[overlayNoRowsTemplate]="overlayNoRowsTemplate"
			[modules]="agGridModules"
			(gridReady)="onGridReady($event)"
			(viewportChanged)="onViewportChanged($event)">
		</ag-grid-angular>
	</div>
</div>
<ng-template #spinner>
	<copo-loading-spinner class="loading-spinner-container-padded"></copo-loading-spinner>
</ng-template>
